import Api from './Api';

export default {
  createDibsyPaymentIntent(payload) {
    return Api().post(
      `/api/dibsy/create-dibsy-intent/${payload.reservation_id}`,
      payload,
    );
  },
  getDibsyPaymentStatus(payload) {
    return Api().post(
      `/api/dibsy/payment-status/${payload.reservation_id}`,
      payload,
    );
  },
  dibsyCallback(payload) {
    return Api().get(`/api/dibsy/callback/${payload.reservation_id}`, payload);
  },
};
